import { Box, Stack, styled, Typography } from "@mui/material";
import { black, text, orange } from "@/theme/colors";
import { FCC } from "@/types/common";
import { convertFullWidthToHalfWidth } from "@/utils/pieces";
import { EMPTY_STR } from "@/constants/string";
import { TCompanyExist } from "@/features/job/types/JobForm";

type TDuplicationCompanyScanProps = {
  listCompanyExists: TCompanyExist[];
  maxWidth?: number;
};

export const DuplicationCompanyScan: FCC<TDuplicationCompanyScanProps> = ({ listCompanyExists, maxWidth }) => {
  return (
    <>
      <BoxStyle>
        <Typography variant="body14Bold" color={text.primary}>
          登録済み同名企業の簡易情報
        </Typography>
        <Typography variant="body14Bold" color={text.secondary}>
          （登録済み重複企業数：{listCompanyExists?.length ?? 0}）
        </Typography>
        <Stack
          direction="column"
          spacing={1}
          sx={{
            mt: 1,
            width: "100%",
            ...(maxWidth && { maxWidth }),
            overflowX: "auto",
            overflowY: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {listCompanyExists.map((company, index) => (
            <Stack key={index} direction="row" alignItems="center">
              <NumberCircle>{index + 1}</NumberCircle>
              <Stack direction="row" alignItems="center" spacing={1} ml={1}>
                <Typography variant="body14" color={text.secondary}>
                  所在地
                </Typography>
                <Separator>|</Separator>
                <Typography variant="body14Bold" color={text.primary}>
                  {convertFullWidthToHalfWidth(company.address) ?? EMPTY_STR.TEXT}
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={1} ml={3}>
                <Typography variant="body14" color={text.secondary}>
                  代表者名
                </Typography>
                <Separator>|</Separator>
                <Typography variant="body14Bold" color={text.primary}>
                  {convertFullWidthToHalfWidth(company.representative) ?? EMPTY_STR.TEXT}
                </Typography>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </BoxStyle>
    </>
  );
};

const BoxStyle = styled(Box)`
  position: relative;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
  padding: 8px;
  margin-top: 16px;
  width: 100%;
  opacity: 1;
  gap: 12px;
  border-radius: 8px;
  background-color: white;

  &::before {
    content: "";
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid white;
    filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.1));
  }
`;

const NumberCircle = styled(Box)`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid ${black[70]};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: ${black[70]};
  flex-shrink: 0;
`;

const Separator = styled(Typography)`
  color: ${black[70]};
  margin: 0 4px;
`;

const TipSection = styled(Box)`
  margin-top: 12px;
  padding: 8px;
  background-color: ${orange[98]};
  border-radius: 4px;
`;
